import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import { DEFAULT_LANGUAGE } from "../enums/language";
import { de } from "./de";
import { en } from "./en";

const resources = {
  de: {
    translation: de,
  },
  en: {
    translation: en,
  },
};

const languageInLocalstorage = localStorage.getItem("language");

i18next.use(initReactI18next).init({
  fallbackLng: DEFAULT_LANGUAGE,
  lng: languageInLocalstorage || DEFAULT_LANGUAGE,
  resources,
});

export default i18next;
